module.exports = __webpack_public_path__ + "img/61200.b6fceb07.jpg";